import * as React from "react"

import Breadcrumb from "./Breadcrumb"
import HierarchyPopup from "./HierarchyPopup"
import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props {
    sortedBreadcrumbs: ResourceHeader.BreadcrumbInfo[]
}

export const CondensedStructure = ({
    sortedBreadcrumbs,
}: Props): JSX.Element => {
    const showFirstParent = sortedBreadcrumbs.length > 1
    const showSecondParent = sortedBreadcrumbs.length > 2
    const showSeparator = sortedBreadcrumbs.length > 3

    return (
        <>
            <HierarchyPopup sortedBreadcrumbs={sortedBreadcrumbs} />

            {showFirstParent && (
                <Breadcrumb
                    key={sortedBreadcrumbs[0].uuid}
                    breadcrumbInfo={sortedBreadcrumbs[0]}
                />
            )}

            {showSeparator && (
                <>
                    <div className="label">{Symbols.EllipsisHorizontal}</div>
                    <span className="tw-mx-2 label">/</span>
                </>
            )}

            {showSecondParent && (
                <Breadcrumb
                    key={sortedBreadcrumbs[sortedBreadcrumbs.length - 2].uuid}
                    breadcrumbInfo={
                        sortedBreadcrumbs[sortedBreadcrumbs.length - 2]
                    }
                />
            )}
        </>
    )
}

export default CondensedStructure
